import { WinRadio, WinCheckbox } from './WinComponents';
import { useState } from 'react';
import DateInput from './DateInput';
import MoneyInput from './MoneyInput';
import MultiRequerantsSection from './MultiRequerantsSection';
import { formatNomPropre, formatNAS, validateNAS, formatCodePostal, formatTelephone, formatAdresse, formatNoBande, formatNoAideSociale, calculerAge } from '../utils/formatters';
import VilleAutocomplete from './VilleAutocomplete';

const RequerantTab = ({ formData, updateFormData, setFormData, provinces, categories, nasError, setNasError, setMessage, showPopup, handleVerifierRefusPrecedent, onTransfertToggle, onReciproToggle, onRevisionToggle, onEditRevisionNote, setShowEtablissement, etablissementSelectionne, clearEtablissement, setCurrentTab, currentDossier, onDateNaissanceLeave }) => {
  const [subTab, setSubTab] = useState('notes'); // 'notes' | 'multireq'
  const sepStyle = { alignSelf: 'stretch', width: '1px', background: '#c2c8d0', margin: '2px 0' };
  return (
  <div className="win-tab-content compact">
    {/* LIGNE 1: IDENTIFICATION (gauche) | COORDONNEES (droite) */}
    <div className="win-two-columns">
      {/* COLONNE GAUCHE: IDENTIFICATION */}
      <fieldset className="win-groupbox compact">
        <legend>Identification</legend>
        <div className="win-compact-grid-2">
          <div className="win-field">
            <label className="win-field-label">Nom</label>
            <input className="win-input" value={formData.nom} onChange={e => updateFormData('nom', formatNomPropre(e.target.value))} data-testid="input-nom" maxLength={40} />
          </div>
          <div className="win-field">
            <label className="win-field-label">Prénom</label>
            <input className="win-input" value={formData.prenom} onChange={e => updateFormData('prenom', formatNomPropre(e.target.value))} data-testid="input-prenom" maxLength={40} />
          </div>
        </div>
        <div className="win-compact-grid-2" style={{marginTop: 8}}>
          <div style={{display: 'grid', gridTemplateColumns: '200px 1fr', gap: 12}}>
            <div className="win-field">
              <label className="win-field-label">Date naissance</label>
              <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                <DateInput value={formData.date_naissance} onChange={v => updateFormData('date_naissance', v)} onBlur={() => onDateNaissanceLeave && onDateNaissanceLeave()} testId="input-date-naissance" style={{width: '110px'}} />
                {calculerAge(formData.date_naissance) !== null && <span style={{fontSize: 12, color: '#555', fontWeight: 'bold', whiteSpace: 'nowrap'}}>{calculerAge(formData.date_naissance)} ans</span>}
              </div>
            </div>
            <div className="win-field" style={{marginLeft: 4}}>
              <label className="win-field-label">Sexe</label>
              <div className="win-radio-group" style={{marginTop: 6}}>
                <WinRadio name="sexe" value="0" checked={formData.sexe === '0'} onChange={v => updateFormData('sexe', v)} label="F" />
                <WinRadio name="sexe" value="1" checked={formData.sexe === '1'} onChange={v => updateFormData('sexe', v)} label="M" />
                <WinRadio name="sexe" value="2" checked={formData.sexe === '2'} onChange={v => updateFormData('sexe', v)} label="Cie" />
                <WinRadio name="sexe" value="3" checked={formData.sexe === '3'} onChange={v => updateFormData('sexe', v)} label="Autres" />
              </div>
            </div>
          </div>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 140px', gap: 12}}>
            <div className="win-field" style={{marginLeft: 4}}>
              <label className="win-field-label">Langue</label>
              <div className="win-radio-group" style={{marginTop: 6}}>
                <WinRadio name="langue" value="1" checked={formData.langue === '1'} onChange={v => updateFormData('langue', v)} label="Fr" />
                <WinRadio name="langue" value="0" checked={formData.langue === '0'} onChange={v => updateFormData('langue', v)} label="En" />
                <WinRadio name="langue" value="2" checked={formData.langue === '2'} onChange={v => updateFormData('langue', v)} label="Es" />
              </div>
            </div>
            <div className="win-field">
              <label className="win-field-label">N.A.S.</label>
              <input 
                className={`win-input ${nasError ? 'input-error' : ''}`}
                value={formData.nas} 
                onChange={e => { updateFormData('nas', formatNAS(e.target.value)); setNasError(''); }}
                onBlur={() => {
                  const result = validateNAS(formData.nas);
                  if (!result.valid) { setNasError(result.message); setMessage(result.message); }
                }}
                placeholder="000-000-000" maxLength={11} data-testid="input-nas"
              />
            </div>
          </div>
        </div>
      </fieldset>

      {/* COLONNE DROITE: COORDONNEES */}
      <fieldset className="win-groupbox compact">
        <legend>Coordonnées</legend>
        <div style={{display: 'grid', gridTemplateColumns: '2fr 1fr 90px 70px', gap: 12}}>
          <div className="win-field">
            <label className="win-field-label">Adresse</label>
            <input className="win-input" value={formData.adresse} onChange={e => updateFormData('adresse', formatAdresse(e.target.value))} maxLength={40} data-testid="input-adresse" />
          </div>
          <div className="win-field">
            <label className="win-field-label">Ville</label>
            <VilleAutocomplete value={formData.ville} onChange={v => updateFormData('ville', formatNomPropre(v))} maxLength={40} testId="input-ville" />
          </div>
          <div className="win-field">
            <label className="win-field-label">Code postal</label>
            <input className="win-input" value={formData.code_postal} onChange={e => updateFormData('code_postal', formatCodePostal(e.target.value))} maxLength={7} placeholder="A1A 1A1" data-testid="input-code-postal" />
          </div>
          <div className="win-field">
            <label className="win-field-label">Prov.</label>
            <select className="win-select" value={formData.province} onChange={e => updateFormData('province', e.target.value)} style={{width: '100%', minWidth: 'unset'}} data-testid="input-province">
              {provinces.map(p => <option key={p.value} value={p.value}>{p.value}</option>)}
            </select>
          </div>
        </div>
        <div style={{display: 'grid', gridTemplateColumns: '120px 120px 65px 120px 1fr', gap: 8, marginTop: 8}}>
          <div className="win-field">
            <label className="win-field-label">Tél. résidence</label>
            <input className="win-input" value={formatTelephone(formData.telephone_residence)} onChange={e => updateFormData('telephone_residence', formatTelephone(e.target.value))} maxLength={12} placeholder="514-555-1234" data-testid="input-telephone" />
          </div>
          <div className="win-field">
            <label className="win-field-label">Tél. bureau</label>
            <input className="win-input" value={formatTelephone(formData.telephone_bureau)} onChange={e => updateFormData('telephone_bureau', formatTelephone(e.target.value))} maxLength={12} placeholder="514-555-1234" />
          </div>
          <div className="win-field">
            <label className="win-field-label">Ext</label>
            <input className="win-input" value={formData.telephone_ext} onChange={e => updateFormData('telephone_ext', e.target.value.replace(/\D/g, '').slice(0, 5))} maxLength={5} placeholder="00000" />
          </div>
          <div className="win-field">
            <label className="win-field-label">Cellulaire</label>
            <input className="win-input" value={formatTelephone(formData.cellulaire)} onChange={e => updateFormData('cellulaire', formatTelephone(e.target.value))} maxLength={12} placeholder="514-555-1234" />
          </div>
          <div className="win-field">
            <label className="win-field-label">Courriel</label>
            <input className="win-input" type="email" value={formData.courriel} onChange={e => updateFormData('courriel', e.target.value.toLowerCase())} maxLength={100} />
          </div>
        </div>
      </fieldset>
    </div>

    {/* LIGNE 2: INFORMATIONS ADMINISTRATIVES */}
    <fieldset className="win-groupbox compact">
      <legend>Informations administratives</legend>
      <div style={{display: 'flex', alignItems: 'flex-end', gap: '18px', flexWrap: 'wrap'}}>
        {(() => {
          // 04=Conjoints sans enfant → pas d'enfants possibles
          // (01=Personne seule reste autorisé — demande utilisateur)
          const sansEnfants = ['04'].includes((formData.categorie_requerant || '').trim());
          return (<>
            <div className="win-field" style={{flex: '0 0 286px', minWidth: 264}}>
              <label className="win-field-label">Catégorie</label>
              <select className="win-select" value={formData.categorie_requerant} onChange={e => {
                const v = e.target.value;
                if (['01', '04'].includes(v)) {
                  setFormData(prev => ({ ...prev, categorie_requerant: v, nb_enfants: 0 }));
                } else {
                  updateFormData('categorie_requerant', v);
                }
              }} style={{width: '100%'}} data-testid="input-categorie">
                {categories.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
              </select>
            </div>
            <div className="win-field">
              <label className="win-field-label">Nb enfants</label>
              <div style={{display: 'flex', gap: 6, alignItems: 'center'}}>
                <input className="win-input" type="text" inputMode="numeric" data-testid="req-nb-enfants" value={formData.nb_enfants} onChange={e => { const v = e.target.value.replace(/\D/g, ''); updateFormData('nb_enfants', v === '' ? 0 : parseInt(v)); }} maxLength={2} style={{width: '50px'}}
                  disabled={sansEnfants}
                  title={sansEnfants ? 'Désactivé : catégorie sans enfant' : undefined} />
                <button
                  type="button"
                  className="win-btn-small"
                  onClick={() => setCurrentTab && setCurrentTab('liens')}
                  data-testid="btn-ouvrir-liens"
                  title="Ouvrir l'onglet Liens pour gérer les enfants et autres liens familiaux"
                >Liens</button>
              </div>
            </div>
          </>);
        })()}
        <div style={sepStyle} />
        <div className="win-field">
          <label className="win-field-label">Montant aide sociale</label>
          <MoneyInput
            value={formData.montant_aide_sociale || 0}
            onChange={v => setFormData(prev => ({ ...prev, montant_aide_sociale: v, montant_aide_sociale_display: undefined }))}
            testId="input-montant-aide-sociale"
            style={{width: '110px'}}
          />
        </div>
        <div className="win-field">
          <label className="win-field-label">No aide sociale</label>
          <input className="win-input" value={formData.no_aide_sociale} onChange={e => updateFormData('no_aide_sociale', formatNoAideSociale(e.target.value))} maxLength={12} placeholder="AAAA######AA" style={{width: '120px'}} />
        </div>
        <div style={sepStyle} />
        <div className="win-field">
          <label className="win-field-label">No bande</label>
          <input className="win-input" value={formData.no_bande} onChange={e => updateFormData('no_bande', formatNoBande(e.target.value))} maxLength={12} style={{width: '110px'}} />
        </div>
        <div style={sepStyle} />
        <div className="win-field">
          <label className="win-field-label">S.E.D.</label>
          <input className="win-input" value={formData.sed} onChange={e => updateFormData('sed', e.target.value.toUpperCase())} maxLength={12} style={{width: '90px'}} />
        </div>
        <div className="win-field">
          <label className="win-field-label">Établissement</label>
          <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
            <button
              type="button"
              className="win-btn-action"
              onClick={() => setShowEtablissement(true)}
              style={{fontSize: '11px', padding: '6px 12px', whiteSpace: 'nowrap', minWidth: '225px', textAlign: 'left'}}
              title="Sélectionner ou éditer un établissement (Détention, Réadaptation, Psy)"
              data-testid="btn-ouvrir-etablissement"
            >
              {etablissementSelectionne ? `${etablissementSelectionne.id_etablis} - ${etablissementSelectionne.nom}` : 'Établissement?'}
            </button>
            {etablissementSelectionne && (
              <button
                type="button"
                className="win-btn-action"
                onClick={() => {
                  if (window.confirm('Retirer l\'établissement et effacer l\'adresse associée ?')) {
                    clearEtablissement();
                  }
                }}
                style={{fontSize: '13px', padding: '4px 8px', color: '#cc0000', fontWeight: 'bold', lineHeight: 1}}
                title="Retirer l'établissement du dossier"
                data-testid="btn-retirer-etablissement"
              >×</button>
            )}
          </div>
        </div>
        <div style={sepStyle} />
        <div className="win-field">
          <label className="win-field-label">&nbsp;</label>
          <button className="win-btn-action" onClick={handleVerifierRefusPrecedent} data-testid="btn-verifier-refus" style={{fontSize: '11px', padding: '6px 10px', whiteSpace: 'nowrap'}}>
            Vérif. refus précédent
          </button>
        </div>
        <div style={sepStyle} />
        <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gridTemplateRows: 'auto auto', gridAutoFlow: 'column', columnGap: '18px', rowGap: '4px'}}>
          <WinCheckbox label="Région éloignée" checked={formData.region_eloignee} onChange={v => updateFormData('region_eloignee', v)} />
          <span style={{display: 'inline-flex', alignItems: 'center', gap: 6}}>
            <WinCheckbox label="Réciprocité/Entente féd." checked={formData.reciprocite} onChange={v => onReciproToggle ? onReciproToggle(v) : updateFormData('reciprocite', v)} />
            {formData.reciprocite && formData.reciprocite_province ? (
              <span data-testid="recipro-province-label" style={{fontSize: '11px', fontWeight: 700, color: '#0033A0'}}>
                ({formData.reciprocite_province})
              </span>
            ) : null}
          </span>
          <span style={{display: 'inline-flex', alignItems: 'center', gap: 6}}>
            <WinCheckbox label="Révision" checked={formData.revision} onChange={v => onRevisionToggle ? onRevisionToggle(v) : updateFormData('revision', v)} />
            {formData.revision ? (
              <button type="button"
                      data-testid="btn-voir-note-revision"
                      onClick={() => onEditRevisionNote && onEditRevisionNote()}
                      title={formData.revision_note ? `Note : ${formData.revision_note}\n(cliquer pour voir / modifier)` : 'Cliquer pour ajouter une note de révision'}
                      style={{fontSize: '11px', fontWeight: 700, color: '#0033A0', cursor: 'pointer',
                              background: '#e8eefc', border: '1px solid #0033A0', borderRadius: 3,
                              padding: '1px 8px', maxWidth: 220, whiteSpace: 'nowrap', overflow: 'hidden',
                              textOverflow: 'ellipsis'}}>
                {formData.revision_note ? `Note : ${formData.revision_note}` : 'Ajouter une note'}
              </button>
            ) : null}
          </span>
          <WinCheckbox label="Transfert" checked={formData.transfert} onChange={v => onTransfertToggle ? onTransfertToggle(v) : updateFormData('transfert', v)} />
        </div>
      </div>
    </fieldset>
    
    {/* SOUS-ONGLETS : Notes non imprimées | Multi-Requérants (parité legacy TabControl3) */}
    <div className="win-notes-section compact" style={{marginTop: 8}}>
      <div className="win-notes-tabs">
        <div
          className={`win-notes-tab ${subTab === 'notes' ? 'active' : ''}`}
          onClick={() => setSubTab('notes')}
          data-testid="subtab-notes"
          style={{cursor: 'pointer'}}
        >
          Notes non imprimées
        </div>
        <div
          className={`win-notes-tab ${subTab === 'multireq' ? 'active' : ''}`}
          onClick={() => setSubTab('multireq')}
          data-testid="subtab-multireq"
          style={{cursor: 'pointer'}}
        >
          Multi-Requérants
        </div>
      </div>
      {subTab === 'notes' && (
        <>
          <textarea
            className="win-textarea"
            value={formData.notes_non_imprimees || ''}
            onChange={e => updateFormData('notes_non_imprimees', e.target.value.slice(0, 100))}
            placeholder="Notes internes (max 100 caractères, non imprimées sur les formulaires officiels)"
            maxLength={100}
            style={{minHeight: 120}}
            data-testid="input-notes-non-imprimees"
          />
          <div style={{fontSize: '11px', color: '#666', textAlign: 'right', marginTop: '2px'}}>
            {(formData.notes_non_imprimees || '').length} / 100 caractères
          </div>
        </>
      )}
      {subTab === 'multireq' && (
        <div style={{padding: 4}}>
          <MultiRequerantsSection noseqdaj={currentDossier?.no_seq_daj || null} setMessage={setMessage} />
        </div>
      )}
    </div>
  </div>
  );
};

export default RequerantTab;
